module.exports = __webpack_public_path__ + "img/cm.79282299.png";